/* eslint-disable react/jsx-curly-newline */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { Fragment } from 'react';
import './styles.less';
import { Grid } from 'semantic-ui-react';
import { Field } from 'redux-form';
import PropTypes from 'prop-types';
import { FormInputField } from '../../../../semantic-ui/components/form-input-field';
import { FormSelect } from '../../../../semantic-ui/components/form-select';
import AddButton from '../../../../components/images/add-button.svg';
import { CustomRequiredComponent } from '../../../../semantic-ui/components/custom-required';
import { normalizeInteger } from '../../../../utils/normalizeInteger';

export const AddressComponent = ({
	fields,
	onAddressSearchChange,
	onAddressChange,
	addressesOptions,
	addressesSearchValue,
	isRegular,
	isAddressesLoading,
	onRemoveAddressFrom,
	onRemoveAddressTo,
}) => {
	return fields.map((name, index) => {
		const searchValue = addressesSearchValue?.[`${name}.address`] || '';

		const isDeleteButtonShown = index !== 0 && index === fields.length - 1;

		const isLastField = index === fields.length - 1;

		const type = name.includes('address_to') ? 'доставки' : 'отгрузки';

		const onRemoveAddress = name.includes('address_to') ? onRemoveAddressTo : onRemoveAddressFrom;

		return (
			<Fragment key={`${name}.address`}>
				<Grid.Row className="address-component__row">
					<Grid.Column width={6} className="address-component__column">
						Адрес {type} #{index + 1}
						{isRegular && <CustomRequiredComponent />}
					</Grid.Column>
					<Grid.Column width={8} className="address-component__column">
						<Field
							name={`${name}.address`}
							type="select"
							component={FormSelect}
							style={{ width: '100%' }}
							autoComplete="off"
							placeholder={`Укажите адрес ${type}`}
							icon="search"
							options={addressesOptions?.[`${name}.address`] || []}
							noResultsMessage="Неизвестный адрес"
							searchValue={searchValue}
							onSearchChange={event => onAddressSearchChange(event, `${name}.address`)}
							onItemChange={value => onAddressChange(value, `${name}.address`)}
							loading={isAddressesLoading[`${name}.address`]}
							dropdownClassName="static"
						/>
					</Grid.Column>
					{isDeleteButtonShown && !isRegular && (
						<Grid.Column width={2}>
							<div
								className="address-component__column_close"
								role="button"
								aria-label="Удалить адрес"
								tabIndex="0"
								onClick={() => {
									fields.remove(index);
									onRemoveAddress(index);
								}}
							/>
						</Grid.Column>
					)}
				</Grid.Row>

				{isRegular && (
					<Grid.Row className="address-component__row">
						<Grid.Column width={6} className="address-component__column">
							Кол. дней со дня выхода машины
							<CustomRequiredComponent />
						</Grid.Column>
						<Grid.Column width={5} className="address-component__column">
							<Field
								name={`${name}.days`}
								type="text"
								normalize={normalizeInteger}
								component={FormInputField}
								autoComplete="off"
								max={100}
								placeholder="Укажите кол. дней"
								value={fields.get(index).days}
							/>
						</Grid.Column>
						{isDeleteButtonShown && (
							<Grid.Column width={3} className="address-component__column">
								<div
									className="address-component__column_close"
									onClick={() => {
										fields.remove(index);
										onRemoveAddress(index);
									}}
								/>
							</Grid.Column>
						)}
					</Grid.Row>
				)}

				{isLastField && (
					<Grid.Row className="address-component__row">
						<Grid.Column width={14} className="address-component__column">
							<div className="address-component__button-row">
								<div className="address-component__button-row-text">Добавить адрес {type}</div>
								<img src={AddButton} alt="add-button" onClick={() => fields.push({})} />
							</div>
						</Grid.Column>
					</Grid.Row>
				)}
			</Fragment>
		);
	});
};

AddressComponent.propTypes = {
	fields: PropTypes.object.isRequired,
	onAddressSearchChange: PropTypes.func.isRequired,
	onAddressChange: PropTypes.func.isRequired,
	addressesOptions: PropTypes.object.isRequired,
	addressesSearchValue: PropTypes.object.isRequired,
	isRegular: PropTypes.bool.isRequired,
	isAddressesLoading: PropTypes.object.isRequired,
	onRemoveAddressFrom: PropTypes.func,
	onRemoveAddressTo: PropTypes.func,
};
